import axios from "axios";

const apiUrl = `${process.env.REACT_APP_SERVER_URL}:${process.env.REACT_APP_SERVER_PORT}`;

export const api = axios.create({
    baseURL: apiUrl,
    headers: {
        "Access-Control-Allow-Origin": "*",
      },
});